import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const WeekdayContainer = styled(Row)`
  border: 0px;
  margin: 0px 0px 3px;
  padding: 8px 15px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -8px #252525;
  border-radius: 15px;
  align-items: center;
  gap: 15px;
`

export const CalendarContainer = styled(Container)`
  padding: 0px;
  margin: 0px 30px 0px 0px;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;

  &:first-child {
    margin-right: 5px;
  }

  &:last-child {
    margin-left: 5px;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const InfoText = styled.p`
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
`

export const WhiteText = styled(Title)`
  color: #FFFFFF;
  margin: 0px;
  font-size: 14px;
  font-weight: 200;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin: 0px;

  &:hover {
    cursor: pointer;
  }
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
